import { UIHeading4, UIText2 } from '@cian/ui-kit';
import classnames from 'classnames';
import * as React from 'react';

import * as styles from './ChatListSupportItem.css';
// @ts-expect-error TODO: исправить импорт картинок
import supportImg from './assets/support.png';

type TChatListSupportItemProps = {
  onClick(): void;
  isLast?: boolean;
};

export const ChatListSupportItem: React.VFC<TChatListSupportItemProps> = ({ onClick, isLast }) => {
  return (
    <div className={classnames(styles['item'], isLast && styles['item--last'])} onClick={onClick} data-chatid="">
      <img className={styles['preview-image']} src={supportImg} />
      <div className={styles['info']}>
        <UIHeading4 whiteSpace="nowrap">Поддержка</UIHeading4>
        <UIText2 color="gray60_100">Отвечаем каждый день с&nbsp;09:00 до&nbsp;21:00 по&nbsp;Москве</UIText2>
      </div>
    </div>
  );
};
